import { getResourcePathUrl } from "./getOwaResourceUrl";

export default function getOwaResourceImageUrl(imageName: string): string {
    return getResourcePathUrl("images/" + imageName);
}
